/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetLoan = (loanNumber: string) => {
  const [loan, setLoan] = useState({
    loanNumber: '',
    PIFReason: '',
    fundingGLAccount: '',
    servStatus: '',
    servicingState: '',
    lpi: 0,
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { reset } = useAbortController();

  const getLoan = useCallback(async () => {
    if (!token || !loanNumber) {
      return;
    }

    setLoading(true);
    const url = 'live/loan/' + loanNumber;

    const controller = reset();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    try {
      let response = await axiosCall({ url: url, method: 'get' }, config, headers);
      setLoan(response);
      setErrorMessage('');
      setLoading(false);
    } catch (error) {
      setErrorMessage('Error Loading Loan. Please check Loan Number.');
      setLoading(false);
      console.error(error.message);
    }
  }, [loanNumber, reset, token]);

  useEffect(() => {
    getLoan();
  }, [getLoan]);

  return {
    loan: loan,
    loanErrorMessages: errorMessage,
    loadingLoan: loading,
  };
};

export default useGetLoan;
